import { useEffect, useState, useSyncExternalStore } from 'react'
import { useQueryClient } from '@tanstack/react-query'

// A captured body belongs to the reader and navigation context that opened it.
// Observe the existing staff session; never start a separate authentication request.
export function useEmailLogSelection(context: string) {
  const client = useQueryClient()
  const scope = useSyncExternalStore(
    (notify) =>
      client.getQueryCache().subscribe((event) => {
        if (event.query.queryKey.length === 1 && event.query.queryKey[0] === 'seat') notify()
      }),
    () =>
      JSON.stringify([
        window.location.origin,
        context,
        client.getQueryData(['seat']),
        client.getQueryState(['seat'])?.dataUpdateCount,
      ]),
  )
  const [selection, setSelection] = useState<{ id: number; scope: string } | null>(null)
  useEffect(() => setSelection(null), [scope])
  const active = Boolean(client.getQueryData<{ seat: unknown }>(['seat'])?.seat)
  return {
    scope,
    id: active && selection?.scope === scope ? selection.id : null,
    open: (id: number) => {
      if (active) setSelection({ id, scope })
    },
    close: () => setSelection(null),
  }
}
